import React, { useState } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch, { SwitchProps } from '@mui/material/Switch';

export type BooleanInputProps = {
  value: boolean;
  label?: string;
  onChange: (value: boolean) => void;
} & Omit<SwitchProps, 'value' | 'onChange'>;

export const BooleanInput: React.FC<BooleanInputProps> = ({
  value,
  label,
  onChange,
  ...rest
}) => {
  const [checked, setChecked] = useState(value);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = event.target.checked;
    setChecked(newChecked);

    onChange(newChecked);
  };

  return (
    <FormControlLabel
      control={
        <Switch
          {...rest}
          checked={checked}
          onChange={handleChange}
          color="primary"
        />
      }
      label={label}
    />
  );
};
